import ctaMapper from './ctaMapper';

export default function bannerBlockMapper(componentsData) {
  const {
    titleSection,
    descriptionSection,
    descriptionBullets = [],
    cta,
    ...rest
  } = componentsData;

  return {
    title: titleSection,
    description: descriptionSection,
    descriptionBullets: descriptionBullets.map(bullet => bullet.value),
    cta: ctaMapper(cta),
    ...rest,
  };
}
